import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { makeGetRequestToUrl } from '../commonFunc.jsx';
import { makePostRequestToUrl } from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Label } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import dayjs, { utc } from "dayjs";
import { Grid2, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from "dayjs/plugin/customParseFormat";
var constants = require('../../constant');

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const PushHistory = () => {
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);

    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [userType, setUserType] = useState(0);
    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState(dayjs());
    const navigate = useNavigate();

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
    };
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');

    const fetchPushHistoryData = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_push_history';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                user_type: userType,
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                setRows(response.data);
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchPushHistoryData();
    }, [startDate, endDate, userType])

    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Push History
            </Typography>

            <Grid2 container spacing={2} alignItems="flex-start" style={{ marginTop: '20px' }}>
                <Grid2 item xs={12} sm={4} md={3}>
                    <Label>User Type</Label>
                    <Select 
                        value={userType} 
                        onChange={(e) => setUserType(e.target.value)} 
                        fullWidth
                        style={{
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                            marginTop: '10px'
                        }}
                    >
                        <MenuItem value="0">Customer</MenuItem>
                        <MenuItem value="1">Driver</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item xs={12} sm={4} md={3}>
                    <Typography>Start Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy == 1 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
                            sx={{
                                width: '100%',
                                marginTop: '2%',
                                '& .MuiInputBase-root': {
                                    width: '80%',
                                    backgroundColor: '#FFFFFF',
                                },
                                '& .MuiOutlinedInput-input': {
                                    height: '50px',
                                    padding: '0 14px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderRadius: '8px',
                                }
                            }}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                }
                            }}
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item xs={12} sm={4} md={3} style={{ marginLeft: '-4.25%' }}>
                    <Typography>End Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy == 1 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
                            sx={{
                                width: '100%',
                                marginTop: '2%',
                                '& .MuiInputBase-root': {
                                    width: '80%',
                                    backgroundColor: '#FFFFFF',
                                },
                                '& .MuiOutlinedInput-input': {
                                    height: '50px',
                                    padding: '0 14px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderRadius: '8px',
                                }
                            }}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                }
                            }}
                            value={endDate}
                            onChange={(newValue) => {
                                if (newValue && dayjs(newValue).isBefore(startDate)) {
                                    alert("End Date cannot be earlier than Start Date");
                                } else {
                                    setEndDate(newValue);
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>User ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>User Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Client ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Title</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Message</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Created At</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            rows.map((row) => {

                                return (
                                    <TableRow key={row.subscription_id}>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_type == 0 ? 'Customer' : 'Driver'}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.client_id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.title}</Typography></TableCell>
                                        <TableCell align="center">
                                        <Typography
                                                component="div"
                                                sx={{
                                                    width: 'auto',
                                                    minWidth: '120px',
                                                    '& strong': { fontWeight: 'bold' },
                                                    '& em': { fontStyle: 'italic' },
                                                    '& u': { textDecoration: 'underline' },
                                                    '& p': { margin: 0 }
                                                }}
                                                dangerouslySetInnerHTML={{ __html: row.message }}
                                            />
                                        </TableCell>                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.created_at?.format('YYYY-MM-DD')} {row.created_at?.format('HH:mm:ss')}</Typography></TableCell> */}
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                {row.created_at ? dayjs.utc(row.created_at).local().format('DD-MM-YYYY HH:mm:ss') : ''}
                                            </Typography>
                                        </TableCell>

                                    </TableRow>
                                )
                            })
                        )}
                    </TableBody>
                </Table>

            </TableContainer>
        </div>
    )
}

export default PushHistory;